import type { ReactNode } from "react";
import { Link } from "react-router";

/** A link where the reader may follow it; plain text where they may not. */
export default function MaybeLink({ to, children }: { to: string | null; children: ReactNode }) {
    if (!to) return <>{children}</>;
    return (
        <Link
            to={to}
            className="font-medium text-brand-600 underline-offset-2 hover:underline dark:text-brand-300"
        >
            {children}
        </Link>
    );
}
